import { render } from "./AddToList.vue?vue&type=template&id=0d9c1a3d"
import script from "./AddToList.vue?vue&type=script&lang=js"
export * from "./AddToList.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Git_repos\\MovieVote\\movievote-client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__